function createListOfPreviousPages(numPages, currentPage) {
    const minPageNr = Math.min(currentPage - 5, numPages - 9);
    const firstPage = Math.max(minPageNr, 1);
    const previousPages = [];
    for (let i = firstPage; i < currentPage; i++) {
        previousPages.push(i);
    }
    return previousPages;
}

function createListOfConsecutivePages(numPages, firstPage, currentPage) {
    const lastPage = Math.min(numPages, firstPage + 9);
    const consecutivePages = [];
    for (let i = currentPage + 1; i <= lastPage; i++) {
        consecutivePages.push(i);
    }
    return consecutivePages;
}

export function pagination(numPages, currentPage) {
    const previousPages = createListOfPreviousPages(numPages, currentPage);
    const consecutivePages = createListOfConsecutivePages(numPages, previousPages[0] || 1, currentPage);

    return {
        showPagination: numPages > 1,
        rewind: currentPage > 2,
        previousPages,
        previousPage: currentPage - 1,
        currentPage,
        nextPage: currentPage + 1,
        consecutivePages,
        numPages,
    };
}
